var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mt-3",attrs:{"flat":"","isDark":_vm.$store.getters.getColorPalette().isDark}},[(_vm.view)?_c(_vm.viewHash[_vm.view.view_type],{tag:"component",attrs:{"view":_vm.view,"showEdit":false}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }